import { Button, Form, Col, Input, Label, Row, FormGroup, FormText, Spinner } from 'reactstrap';
import ReactSelect from 'react-select';
import { documentsOptions } from '../../../helpers/documentsOptions';
import isAdmin from '../../../helpers/isAdmin';
import { isDirector } from '../../../helpers';
import isHRUser from '../../../helpers/isHRUser';

type Props = {
  loggedUser: any;
  showForm: boolean;
  setShowForm: (showForm: boolean) => void;
  setDocumentType: (documentType: string) => void;
  setDocumentFile: (d: any) => void;
  onSaveFile: (e: any) => void;
  loadingUploadDocuments?: boolean;
};

const UploadDocumentsForm = ({
  loggedUser,
  showForm,
  setShowForm,
  setDocumentType,
  setDocumentFile,
  onSaveFile,
  loadingUploadDocuments = false,
}: Props) => {
  const onChangeFile = (event: any) => {
    event.stopPropagation();
    event.preventDefault();
    const file = event.target.files[0];
    setDocumentFile(file);
  };

  const currentDocumentsOptions =
    isAdmin(loggedUser) || isDirector(loggedUser) || isHRUser(loggedUser)
      ? documentsOptions
      : documentsOptions.filter((d) => d.value !== 'E-verify Confirmation');
  return (
    <Col style={{ paddingLeft: '20px', paddingRight: '20px', marginTop: '20px' }}>
      <Row>
        {!showForm && (isAdmin(loggedUser) || isDirector(loggedUser) || isHRUser(loggedUser)) && (
          <Col>
            <Button
              size="sm"
              color="primary"
              onClick={() => {
                setShowForm(true);
              }}
            >
              + Upload I9 Documents
            </Button>
          </Col>
        )}
        {showForm && (
          <Col lg="12">
            <Form onSubmit={(e: any) => e.preventDefault()}>
              <Row>
                <Col lg="6">
                  <FormGroup style={{ fontSize: '0.8125rem', whiteSpace: 'nowrap', marginTop: '20px' }}>
                    <Label>Document Type</Label>
                    <ReactSelect
                      isSearchable
                      defaultValue={currentDocumentsOptions[0]}
                      options={currentDocumentsOptions}
                      onChange={(e: any) => (e?.value ? setDocumentType(e.value) : null)}
                    />
                  </FormGroup>
                </Col>
                <Col lg="6">
                  <FormGroup style={{ fontSize: '0.8125rem', whiteSpace: 'nowrap', marginTop: '20px' }}>
                    <Label for="document-upload">Document</Label>
                    <Input
                      id="document-upload"
                      name="file"
                      type="file"
                      onChange={onChangeFile}
                      accept=".png,.jpg,.jpeg,.pdf"
                    />
                    <FormText>File extensions: PNG, JPG and PDF</FormText>
                  </FormGroup>
                </Col>
                <Col md="12">
                  <Button
                    color="primary"
                    type="button"
                    size="sm"
                    style={{ minWidth: '100px' }}
                    onClick={onSaveFile}
                    disabled={loadingUploadDocuments}
                  >
                    {loadingUploadDocuments ? (
                      <>
                        <Spinner size="sm" style={{ marginRight: '8px' }} /> Saving...
                      </>
                    ) : (
                      'Save'
                    )}
                  </Button>

                  <Button
                    color="secondary"
                    size="sm"
                    style={{ minWidth: '100px' }}
                    onClick={(e) => {
                      e.preventDefault();
                      setShowForm(false);
                    }}
                    disabled={loadingUploadDocuments}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        )}
      </Row>
    </Col>
  );
};

export default UploadDocumentsForm;
